import React from 'react';
import FramerSlide from '../Common/FramerSlide'
import { desktopStyles, mobileStyles } from '../../configuration/framer-slide-styles';
import './BookTour.css';
import Footer from '../Footer/Footer';
import { Helmet } from 'react-helmet';

export default function BookTour() {
  return (
    <div style={{ textAlign: 'center' }}>
      <Helmet>
          <meta charSet="utf-8" />
          <title>Book A Tour Today | Aqua Bayonne | Bayonne NJ Apts</title>
          <meta name="description" content="Inquire now to book a tour and see why Aqua Bayonne defines luxury living in Bayonne, NJ"/>
      </Helmet>
      <FramerSlide text="Book A Tour" desktopTextStyles={desktopStyles} mobileTextStyles={mobileStyles} />
        <div className="book-a-tour-container" style={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
          <iframe
            title="Calendly"
            src="https://calendly.com/aqualeasing"
            width="100%"
            height="100%"
            style={{ position: 'absolute', top: 0, left: 0 }}
          ></iframe>
        </div>
        <Footer />
    </div>
  );
}
